import { render } from "./rank-distribute-dialog.vue?vue&type=template&id=507203ce&scoped=true"
import script from "./rank-distribute-dialog.vue?vue&type=script&lang=js"
export * from "./rank-distribute-dialog.vue?vue&type=script&lang=js"

import "./rank-distribute-dialog.vue?vue&type=style&index=0&id=507203ce&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507203ce"]])

export default __exports__